import { useEffect } from "react";
import { PageControl, KIND } from "baseui/page-control";
import { useNavigate } from 'react-router-dom';
import { Analytics, Gtag } from '../../compornents/Analytics';
import React from 'react';

export const OrderStep4 = () => {
  const navigate = useNavigate();


  const next = () => {
    navigate('/order_step/step5');
  }

  useEffect(() => {
    Gtag('view_order_step4');
  }, []);

  return (
    <div>
      <div>
        <Analytics title="OrderStep4" />
        <div className="Register">
          <div className="App-step1">
            <div className="App-h1 pt-5">{"STEP.4"}</div>
            <img src="/img/step3.png" alt="step4" className="App-img" />
            <div className="App-title">クリーニング完了</div>
            <div className="App-comment">クリーニングが完了したら<br />SMSで通知されます。</div>
            <div className="App-h3">
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '20px',
                }}
              >
                <PageControl
                  currentPage={5}
                  numPages={6}
                  kind={KIND.default}
                  aria-label="label"
                />
              </div>
              <button className="button-next-w" onClick={next}>{"次へ"}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
